import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=1aa710f8&"
import script from "./imgDialog.vue?vue&type=script&lang=js&"
export * from "./imgDialog.vue?vue&type=script&lang=js&"
import style0 from "./imgDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/imgDialog.vue
// module id = null
// module chunks = 